import { createRouter, createWebHistory } from 'vue-router'
import { orgRoutes } from '@/config/orgMenu'

const routes = [
  {
    path: '/',
    redirect: '/org/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/org/login',
    name: 'OrgLogin',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/org/dashboard/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/org/dashboard/reset-password.vue'),
    hidden: true
  },
  // 机构后台固定路由
  ...orgRoutes,
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    hidden: true
  }
]

// 获取 BASE_URL，如果没有设置则使用 '/'
const baseUrl = process.env.BASE_URL || '/'

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes
})

export default router